import { render, staticRenderFns } from "./user.vue?vue&type=template&id=61fa67d6&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=61fa67d6&prod&lang=css&"
import style1 from "./user.vue?vue&type=style&index=1&id=61fa67d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa67d6",
  null
  
)

export default component.exports